module.exports = __webpack_public_path__ + "static/img/13.b357c62.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/sp/13.png
// module id = 79XG
// module chunks = 0